export const DISTRIBUTE_AMOUNT = Number(
  process.env.NEXT_PUBLIC_DISTRIBUTE_AMOUNT ?? "10000"
);

// Staking is deprecated: no new deposits are accepted and no staking rewards
// are distributed anymore. Existing stakers can still unstake and withdraw.
// Set NEXT_PUBLIC_STAKING_DEPRECATED="false" to bring deposits + APR back.
export const isStakingDeprecated =
  (process.env.NEXT_PUBLIC_STAKING_DEPRECATED ?? "true").toLowerCase() !==
  "false";

export const STAKING_PAUSED_TITLE = "Staking Paused";

export const STAKING_PAUSED_MESSAGE =
  "Staking has been paused, so no new deposits can be made. If you have deposited before, you can unstake and withdraw all of your tokens. No staking rewards are being given anymore.";

// Shown inside the STAKE tab itself, so it points to what you can still do
// instead of repeating the status card above.
export const STAKING_PAUSED_TAB_TITLE = "No New Deposits";

export const STAKING_PAUSED_TAB_MESSAGE =
  "Staking is closed and rewards have stopped. Your existing stake isn't affected, so you can unstake it and withdraw in full.";

export interface INetwork {
  // chainId: number;
  // chainName: string;
  // rpcUrls: string[];
  // nativeCurrency: {
  //   name: string;
  //   symbol: string;
  //   decimals: number;
  // };
  blockExplorerUrls: string[];
  cooldownDays: number;
  tokenAddress?: string;
}

export type NetworkType = "testnet" | "mainnet";

export const networkMap: Record<NetworkType, INetwork> = {
  testnet: {
    // chainId: 84532,
    // chainName: "Base Sepolia",
    // rpcUrls: [SPHERON_DEVNET_RPC_URL],
    // nativeCurrency: {
    //   name: "Sepolia Ether",
    //   symbol: "ETH",
    //   decimals: 18,
    // },
    cooldownDays: 0.0125,
    blockExplorerUrls: ["https://sepolia.basescan.org/"],
  },
  // TODO: NEED TO UPDATE WHEN MAINNET RELEASE
  mainnet: {
    // chainId: 421614,
    // chainName: "Arbitrum Sepolia",
    // rpcUrls: ["https://sepolia-rollup.arbitrum.io/rpc"],
    // nativeCurrency: {
    //   name: "Ethereum",
    //   symbol: "ETH",
    //   decimals: 18,
    // },
    cooldownDays: 7,
    blockExplorerUrls: ["https://sepolia.arbiscan.io/"],
  },
};

export const networkType: NetworkType =
  (process.env.NEXT_PUBLIC_NETWORK_TYPE as NetworkType) || "testnet";
